<template>
  <v-form v-model="valid" ref="form">
    <v-card class="pt-3 container">
      <v-card-title>
        <span class="headline">{{$t('bank_account')}}</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col md="12" class="pb-0 pt-0">
            <v-autocomplete
              :label="$t('bank_name')"
              v-model="formData.bankId"
              :rules="rules2"
              :items="bankList"
              item-text="name"
              item-value="id"
              required
              class="sae-required"
            ></v-autocomplete>
          </v-col>
          <v-col md="12" class="pb-0 pt-0">
            <v-text-field
              :label="$t('account_name')"
              v-model="formData.accountName"
              type="text"
              :rules="[...rules, validator.alfaNumberNotRequired]"
              required
              class="sae-required"
            ></v-text-field>
          </v-col>
          <v-col md="12" class="pb-0 pt-0">
            <v-text-field
              :label="$t('account_number')"
              v-model="formData.accountNumber"
              type="text"
              :rules="rules4"
              required
              class="sae-required"
            ></v-text-field>
          </v-col>
          <v-col md="12" class="text-center">
            <!-- <v-btn plain class="ma-2 primary--text">Cancel</v-btn> -->
            <v-btn
              color="primary"
              class="ma-2"
              :disabled="!valid"
              :loading="loading"
              @click="saveOrUpdate(formData)"
            >{{$t('save')}}</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-form>
</template>

<script>
import moment from 'moment'

export default {
  props: ['userId', 'bankAccount'],
  name: "BankAccount",
  data() {
    return {
      rules: [(value) => (value === 0 ? true : !!value || this.$i18n.t('required'))],
      rules2: [(value) => (value == 0 ? true : value ? value > 0 : !!value || this.$i18n.t('required'))],
      rules4: [
        v => /^[0-9]+$/.test(v) || this.$i18n.t('number_required'),
        (value) => (value === 0 ? true : !!value || this.$i18n.t('required'))
      ],
      bankList: [],
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      valid: false,
      formData: {},
      userIdLogin: this.$store.getters.user.id,
      loading: false,
      isEdit: false,
    }
  },
  methods: {
    costumHeader(actionId, action) {
      return { headers: { actionId, action } }
    },
    formatTime(date) {
      return moment(date).format("Do MMMM YYYY")
    },
    async getBanks() {
      this.loading = true
      this.bankList = await this.$store.dispatch('getBanks')
      this.loading = false
    },
    async saveOrUpdate(data) {
      if (this.isEdit) {
        this.editComponent(data)
      } else {
        this.saveComponent(data)
      }
    },
    async saveComponent(data) {
      const body = { ...data, userId: this.userId }
      this.loading = true
      const result = await this.$store.dispatch('saveBankAccount', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.$emit('reload', true)
        this.tab = 0
      }
    },
    async editComponent(data) {
      const body = { ...data }
      this.loading = true
      const result = await this.$store.dispatch('editBankAccount', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.$emit('reload', true)
        this.tab = 0
      }
    },
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', { type, msg })
    },
    refreshData() {
      if (this.bankAccount) {
        this.formData = Object.assign({}, this.bankAccount)
        this.formData.bankId = parseInt(this.formData.bankId)
        this.isEdit = true
      } else {
        if (this.$refs.form && !this.isEdit) {
          this.$refs.form.reset();
        }
        this.formData = []
        this.isEdit = false
      }
    },
  },
  created() {
    this.refreshData()
    this.getBanks()
  },
  watch: {
    bankAccount() {
      this.refreshData()
    },
    userId() {
      this.refreshData()
    },
  }
}
</script>
